module.exports = __webpack_public_path__ + "img/FIMBA.b60377eb.png";